(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "prop-types", "react", "./BaseField"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("prop-types"), require("react"), require("./BaseField"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.propTypes, global.react, global.BaseField);
    global.FormValueScope = mod.exports;
  }
})(this, function (_exports, _propTypes, _react, _BaseField) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports["default"] = void 0;
  _propTypes = _interopRequireDefault(_propTypes);
  _react = _interopRequireDefault(_react);
  _BaseField = _interopRequireDefault(_BaseField);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

  function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

  function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

  function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

  function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

  function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

  function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function parseName(name) {
    // only split string names by dots, but keep non string names (for example number names
    // like in IteratorField) as they are
    return typeof name === 'string' ? name.split(/\./g) : [name];
  } // is kind of inherited by Form
  // make sure to mirror changes in here also in Form


  var FormValueScopeContext = _BaseField["default"].contextType;

  var FormValueScope =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(FormValueScope, _React$Component);

    function FormValueScope() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, FormValueScope);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FormValueScope)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "getValue", function (name) {
        var outerScope = _this.context.instance;
        var ownName = _this.props.name;
        var value = outerScope.getValue(ownName);

        if (name !== undefined && name !== null) {
          return value ? value.getIn(parseName(name)) : undefined;
        } else {
          return value;
        }
      });

      _defineProperty(_assertThisInitialized(_this), "setValue", function (name, value) {
        var outerScope = _this.context.instance;
        var ownName = _this.props.name;

        if (name !== undefined && name !== null) {
          return outerScope.setValue(ownName, outerScope.getValue(ownName).setIn(parseName(name), value));
        } else {
          return outerScope.setValue(ownName, value);
        }
      });

      _defineProperty(_assertThisInitialized(_this), "getError", function (name) {
        var outerScope = _this.context.instance;
        var ownName = _this.props.name;
        var error = outerScope.getError(ownName);
        return error ? error.getIn(parseName(name)) : undefined;
      });

      return _this;
    }

    _createClass(FormValueScope, [{
      key: "render",
      value: function render() {
        return _react["default"].createElement(FormValueScopeContext.Provider, {
          value: {
            instance: this,
            state: this.state
          }
        }, this.props.children);
      }
    }, {
      key: "name",
      get: function get() {
        var outerScope = this.context.instance;
        var ownName = this.props.name;
        return "".concat(outerScope.name, ".").concat(ownName);
      }
    }]);

    return FormValueScope;
  }(_react["default"].Component);

  _defineProperty(FormValueScope, "contextType", FormValueScopeContext);

  _defineProperty(FormValueScope, "propTypes", {
    name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
    children: _propTypes["default"].element.isRequired
  });

  var _default = FormValueScope;
  _exports["default"] = _default;
});